module.exports = __webpack_public_path__ + "img/error_round_red.2838d37a.svg";